import React, { useEffect, useRef,useMemo } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import dayjs from "dayjs";
import _ from 'lodash';

const BulletChart = ({
    maxValue, divId,height, targetValue, actualValue, unit, width
  }) => {

const difference = actualValue-targetValue;
const formattedMaxValue = maxValue >= 1000 ? maxValue / 10000 : maxValue;
const formattedActualValue = actualValue >= 1000 ? actualValue / 10000 : actualValue;
const formattedTargetValue = targetValue >= 1000 ? targetValue / 10000 : targetValue;


    useEffect(() => {

        let root = am5.Root.new(divId);
        root.setThemes([
            am5themes_Animated.new(root)
          ]);


          var chart = root.container.children.push(
            am5xy.XYChart.new(root, {
              panX: false,
              panY: false,
              wheelX: "none",
              wheelY: "none",
              arrangeTooltips: false
            })
          );


    let tooltip = am5.Tooltip.new(root, { });


    chart.plotContainer.set("tooltipPosition", "pointer");
    chart.plotContainer.set("tooltipText", "a");
    chart.plotContainer.set("tooltip", tooltip);
    tooltip.label.adapters.add("text", function (text, target) {
        text = "";
        let i = 0;
        chart.series.each(function (series) {
          let tooltipDataItem = series.get("tooltipDataItem");

          if (i === 0) {
            text += "[bold fontSize: 12px]" + divId + "\n";
          }
  
          if (tooltipDataItem) {
            if (i !== 0) {
              text += "\n";
            }
  
            if (tooltipDataItem.get("valueX")) {
              text +=
              "[" +
              series.get("stroke") +
              "]■[/] [width:8px][fontSize: 12px]" +tooltipDataItem.dataContext.type +
                ": " +
                Number(
                  (tooltipDataItem.get("valueX") ?? 0).toFixed(2)
                ).toLocaleString() + (maxValue >= 1000 ? "만":"")+
                " " +
                (unit)
  
            }
          }
          i++;
        });
        return text;
      });

    tooltip.get("background").setAll({
        stroke: am5.color(0x000000),
        strokeOpacity: 0.8,
        fill: am5.color(0xffffff),
        fillOpacity: 0.8,
      });
  
        
          var yAxis = chart.yAxes.push(
            am5xy.CategoryAxis.new(root, {
              categoryField: "category",
              renderer: am5xy.AxisRendererY.new(root, {})
            })
          );
        
          yAxis.data.setAll([
            { category: "" },

          ]);

          
          var xRenderer = am5xy.AxisRendererX.new(root, {

            minGridDistance: width/5, // 10개의 눈금을 표시하도록 설정

          });
          xRenderer.grid.template.set("forceHidden", true);
        
          var xAxis = chart.xAxes.push(
            am5xy.ValueAxis.new(root, {
              renderer: xRenderer,
              min: 0,
              max: formattedMaxValue,
              strictMinMax: true,
              numberFormat: maxValue >= 1000 ? `#,###.0 '${unit}'` : `#,###.'${unit}'`,
              endLocation: 1 // 마지막 눈금을 항상 표시하도록 설정
            })
          );

          
          
          xAxis.get("renderer").labels.template.setAll({
            fontSize:'10px'
          });

          xAxis.get("renderer").grid.template.setAll({
            strokeOpacity: 1, // 눈금 선의 불투명도 설정
            strokeDasharray: [3, 3], // 눈금 선의 대시 배열 설정
            stroke: am5.color(0x000000)
          });


    
          var rangeDataItem = xAxis.makeDataItem({ value: 0, endValue: formattedMaxValue });
          var range = xAxis.createAxisRange(rangeDataItem);



          range.get("axisFill")?.setAll({
              visible: true,
              fill:"#F5F5F5" ,
              stroke: "#F5F5F5",
              fillOpacity:1
            });

          var series = chart.series.push(
            am5xy.ColumnSeries.new(root, {
              xAxis: xAxis,
              yAxis: yAxis,
              valueXField: "value",
              categoryYField: "category",
              stroke:"#0583F2",
              fill:difference>0?"#0583F2":'#0583F2',

            })
          );
        
          series.columns.template.setAll({
            height: am5.p50
          });

          series.data.setAll([{ category: "", value: formattedActualValue,type:"실적" }]);

          var stepSeries = chart.series.push(
            am5xy.StepLineSeries.new(root, {
              xAxis: xAxis,
              yAxis: yAxis,
              valueXField: "value",
              categoryYField: "category",
              stroke: "#FEAE65",
              fill: "#FEAE65",
              noRisers: true,
              stepWidth: am5.p100,
            //   tooltip: am5.Tooltip.new(root, {
            //     pointerOrientation: "left",
            //     labelText: `{valueX}${unit}`
            //   })
            })
          );
        
          stepSeries.strokes.template.set("strokeWidth", 3);
          stepSeries.data.setAll([{ category: "", value: formattedTargetValue , type:"계획"}]);
        
          // Add cursor
          // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/%
          var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
            behavior: "none"
          })
          );
          cursor.lineY.set("visible", false);
          cursor.lineX.set("visible", false);
        


        chart.appear(1000, 100);

        // appear 이벤트 이후에 remainingLabel 생성 및 adapters.add() 호출
        series.events.once("datavalidated", function () {
            var remainingLabel = chart.plotContainer.children.push(
              am5.Label.new(root, {
                text: `${(formattedMaxValue - formattedActualValue).toFixed(1)}${maxValue >= 1000 ? "만" : ""} ${unit}`,
                fontSize: 12,
                fontWeight: "bold",
                fill: am5.color(0x000000),
                centerY: am5.p0,
                centerX: am5.p100,
                // x:am5.p100,
                // paddingRight: 10,
                opacity: 0.7
              })
            );
          
              remainingLabel.set("x", am5.percent(100));
          });
          

        return () => {
    
          root && root.dispose();
        };
      }, [
        formattedMaxValue, divId, formattedTargetValue, formattedActualValue
      ]);
    



    return (  
        <div id={divId} style={{width:"100%", height:height}} ></div>
    );
};

export default BulletChart;